import {
    createRef
} from "react"
import {
    Vector3
} from "three"

const productsPage = {
    id: "productsPage",
    title: "digitalProducts",
    sections: 9,
    pages: 8,
    zoom: 75,
    intro: {
        header: "introHeader",
        text: "introText",
    },
    footer: {
        text: "footerText",
    },
    colors: {
        header: "#FD0262",
        hugeText: "#BAFF00",
    },
    paragraphs: [{
            factor: 1.75,
            header: "paragraph1Header",
            image: "dot-hotels.png",
            aspect: 1.51,
            text: "paragraph1",
            diamond: { x: 2, offset: 0, pos: new Vector3(), scale: 1.8, factor: 2.1 },
        },
        {
            factor: 2.0,
            header: "paragraph2Header",
            image: "osp.png",
            aspect: 1.5,
            text: "paragraph2",
            diamond: { x: -5, offset: 0, pos: new Vector3(), scale: 1.8, factor: 2.5 },
        },
        {
            factor: 2.25,
            header: "paragraph3Header",
            image: "sc.webp",
            aspect: 1.5037,
            text: "paragraph3",
            diamond: { x: 0, offset: 0, pos: new Vector3(), scale: 1.8, factor: 1.75 },
        },
        {
            factor: 2.25,
            header: "paragraph4Header",
            image: "tiempo-ar.png",
            aspect: 1.5037,
            text: "paragraph4",
            diamond: { x: 0, offset: 0, pos: new Vector3(), scale: 1.8, factor: 2.5 },
        },
        {
            factor: 1.75,
            header: "paragraph5Header",
            image: "gloria.png",
            aspect: 1.55,
            text: "paragraph5",
            diamond: { x: 2, offset: 0, pos: new Vector3(), scale: 2.25, factor: 0.85 },
        },
        {
            factor: 0.25,
            header: "Can you see your future now?.",
        },
        {
            factor: 0.25,
            hugeText: "Let’s travel this path together.",
        },
        {
            factor: 0.25,
            hugeText: "hi@genosha.com",
            onClick: (e) => window.location.href = "mailto:hi@genosha.com",
        }
    ],
    stripes: [{
            offset: 0,
            color: "#000",
            height: 13
        },
        {
            offset: 6.3,
            color: "#000",
            height: 20
        }
    ],
    model: "cat_crystal.glb",
    top: createRef()
};

const experiencesPage = {
    id: "experiencesPage",
    title: "experiences",
    sections: 9,
    pages: 8,
    zoom: 75,
    colors: {
        header: "#BAFF00",
        hugeText: "#FD0262",
    },
    paragraphs: [
        {
            factor: 1.75,
            header: "paragraph1Header",
            image: "photo-1515036551567-bf1198cccc35.jpeg",
            video: "nissan/nissan.mp4",
            aspect: 1.9991,
            text: "paragraph1",
            diamond: { x: 2, offset: 0, pos: new Vector3(), scale: 1.8, factor: 2.1 },
        },
        {
            factor: 2.0,
            header: "paragraph2Header",
            aspect: 1.766666666666667,
            text: "paragraph2",
            video: "t10/t10.mp4",
            diamond: { x: -5, offset: 0, pos: new Vector3(), scale: 1.8, factor: 2.5 },
        },
        {
            factor: 2.25,
            header: "paragraph3Header",
            image: "ph1.jpg",
            aspect: 1.9991,
            text: "paragraph3",
            video: "intel/intel.mp4",
            diamond: { x: 0, offset: 0, pos: new Vector3(), scale: 1.8, factor: 1.75 },
        },
        {
            factor: 2.0,
            header: "paragraph4Header",
            image: "ph3.jpg",
            aspect: 1.9991,
            text: "paragraph4",
            video: "mva/movistar-arena-web.mp4",
            
            diamond: { x: -5, offset: 0, pos: new Vector3(), scale: 1.8, factor: 2.5 },
        },
        {
            factor: 1,
            hugeText: "Can you see your future now?.",
        },
        {
            factor: 1,
            hugeText: "Let’s travel this path together.",
        },
        {
            factor: 1,
            hugeText: "hi@genosha.com",
            onClick: (e) => window.location.href = "mailto:hi@genosha.com",
        }
    ],
    stripes: [
        {
            offset: 0,
            color: "#000",
            height: 13
        },
        {
            offset: 6.3,
            color: "#000",
            height: 20
        }
    ],
    model: "cat_crystal.glb",
    top: createRef()
};

export default {
    order: [experiencesPage, productsPage],
    productsPage,
    experiencesPage,
};
